import * as React from 'react';
import {ContextProvider} from './Context';
import BoxContainer from 'containers/BoxContainer';
import {Header} from './components/Header';
import {Content} from './components/Content';
import {BlockProps} from './types';

/**
 * The block component.
 * @param {BlockProps} props
 * @return {React.ReactElement<BlockProps>}
 * @constructor
 */
export default function Block(
    props: BlockProps,
): React.ReactElement<BlockProps> {
  return (
    <ContextProvider value={{
      block: props,
      index: props.index,
    }}>
      <BoxContainer>
        <Header />
        <Content />
      </BoxContainer>
    </ContextProvider>
  );
}
